<div class="modal-body text-center">
  <p>{{ dialogTranslation }}</p>
  <button type="button" class="btn btn-outline-danger me-3" (click)="delete()">
    {{ actionButtonTranslation | translate }}
  </button>
  <button type="button" class="btn btn-secondary ms-3" (click)="bsModalRef?.hide()">
    {{ 'misc.cancel_btn' | translate }}
  </button>
</div>
